/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

export const fileToBase64 = async (file: File): Promise<string> => {
  return new Promise((resolve, reject) => {
    const fileReader = new FileReader();
    fileReader.onerror = (e): void => reject(fileReader.error);
    fileReader.onloadend = (e): void => {
      const dataUrl = fileReader.result as string;
      // remove "data:mime/type;base64," prefix from data url
      const base64 = dataUrl.substring(dataUrl.indexOf(',') + 1);
      resolve(base64);
    };
    fileReader.readAsDataURL(file);
  });
};
